import { DecimalPipe } from '@angular/common';
import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { PartListModel, PartsListViewModel, AdditionalPartList, AlternatePartList, ReplacementPartList } from '../../../business-entities/parts-list-view-model';
import { PartsBusinessService } from '../../../business-services/parts.service';
import * as Enums from './../../../../../../Autofacets-Core/src/app/utils/enums';
import { BrandType } from '../../../business-entities/vehicle-list-view-model';
import { BrandService } from '../../../business-services/brand.service';
import { CookieService } from 'ngx-cookie-service';
import { UserDataService } from 'src/app/DataServices/user-data.service';

@Component({
  selector: 'app-edit-parts',
  templateUrl: './edit-parts.component.html'
})
export class EditPartsComponent implements OnInit, OnDestroy {
  partsId: number;
  partNumber:string;
  partsDetail: PartsListViewModel;
  editPartForm: FormGroup;
  costTypeData = [];
  languageList: any[];
  partList: PartListModel;
  makeList: BrandType[] = [];
  makeCode: string;
  dropdownSettings = {};
  selectedAdditionalItems:any[]=[];
  selectedAdditionalItemsString:string = '';
  selectedAlternateItems:any[]=[];
  selectedAlternateItemsString:string = '';
  selectedReplacementItems:any[]=[];
  selectedReplacementItemsString:string = '';
  additionalPartsList: PartsListViewModel[] = [];
  alternatePartsList:PartsListViewModel[] = [];
  replacementPartsList:PartsListViewModel[] = [];
  initialAdditionalLoad:boolean = false;
  initialAlternateLoad:boolean = false;
  initialReplacementLoad:boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private partService: PartsBusinessService,
    private toaster: ToastrService,
    private decimalPipe: DecimalPipe,
    private currentLanguageService: CurrentLanguage,
    private translate: TranslateService,
    private globalSetting:GlobalSetting,
    private activeModal : NgbActiveModal,
    private brandService: BrandService,
    private cookieservice: CookieService,
    private userService: UserDataService,
    private cdr: ChangeDetectorRef,) { }

  ngOnInit(): void {
    this.languageList = this.currentLanguageService.LanguageList;
    this.editPartForm = this.formBuilder.group({
      partNumber: ['', [Validators.required]],
      service: new FormArray([]),
      costType: [null],
      unitPrice: [''],
      isActive: [false],
      makeCode: ['', [Validators.required]],
      isFixed:[false]
    });
    this.getLanguage();
    this.GetAllMake();
    this.costTypeData = [{ id: 1, name: "Personnel" }, { id: 2, name: "Material" }, { id: 3, name: "External" }]
    if(this.partService.costType)
      this.partService.isEdit = true;
    this.getParts();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'description',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
      maxHeight: 500
    };
  }
  get t() { return this.cpf.service as FormArray; }
  getLanguage() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.t.length < number) {
        for (let i = this.t.length; i < number; i++) {
            this.t.push(this.formBuilder.group({
                languageId: ['',],
                name: ['', Validators.required],
                description: ['', Validators.required],
            }));
        }
    } else {
        for (let i = this.t.length; i >= number; i--) {
            this.t.removeAt(i);
        }
    }
}

async GetAllMake(): Promise<void> {
  this.makeList = await this.brandService.GetBrandDropdownResult();
  this.getAllParts()
}
async getAllParts() {
  this.spinner.show();
  let model = {
    makeCode: "",
    description:  "",
    no:  "",
    languageCode:this.cookieservice.get('userSelectedLanguage'),
    dealerId: ""
  }
  await this.partService.getParts(model).then(response => {
    this.additionalPartsList=response.filter(s => s.makeCode == this.makeCode && s.partNumber != this.partList.partLists.partNumber);
    this.alternatePartsList=response.filter(s => s.makeCode == this.makeCode && s.partNumber != this.partList.partLists.partNumber);
    this.replacementPartsList=response.filter(s => s.partNumber != this.partList.partLists.partNumber);
    this.spinner.hide();
  }, _error => {
    this.spinner.hide();
  });

}
OnMakeChange(){
  this.selectedAdditionalItems = [];
  this.selectedAlternateItems = [];
  this.selectedReplacementItems = [];
  this.getAllParts();
}
  async getParts() {
    this.partNumber = this.partService.partNumber;
    this.partsId = this.partService.partId;
    await this.getPartById(this.partNumber);
  }
  async getPartById(partNumber: string) {
    this.spinner.show();

    await this.partService.getPartById(partNumber).then(async (response) => {
      if (response.responseCode === Constant.SuccessResponseCode) {
        this.partList = response.responseObject;
        let unitPrice = this.decimalPipe.transform(this.partList.partLists.unitPrice, "1.2-2");
        let decimalUnitPrice = unitPrice.toString().replace(/,/g, "");
        this.editPartForm.patchValue({
          unitPrice: decimalUnitPrice,
          partNumber: this.partList.partLists.partNumber,
          isActive: this.partList.partLists.isActive,
          service: this.partList.languageDetails,
          isFixed:this.partList.partLists.isFixed
        });
        this.makeCode = this.partList.partLists.makeCode;
        await this.getAllParts();
        this.cdr.detectChanges();
        this.MapAdditionalPart();
        this.MapAlternatePart();
        this.MapReplacementPart();
        this.cdr.detectChanges();
      }
      else if (response.responseObject && response.responseObject.errorCount > 0) {
        if (response.responseObject.result &&
          response.responseObject.result.errorCode === Enums.ErrorCodes.PartNotfound) {
          this.toaster.error(Enums.ToastrMessages.PartNotfound);
        }
      }
      this.spinner.hide();
    });

  }
  async MapAdditionalPart()
  {
    if(this.partList.additionalPartList)
    {
      if (this.additionalPartsList && this.partList.additionalPartList?.length > 0) {
        this.additionalPartsList.forEach(x => {
          this.partList.additionalPartList.forEach(y => {
            if (x.partNumber == y.additionalPartNumber) {
              let Obj = {
                id:x.id,
                description:x.description
              };
              this.selectedAdditionalItems.push(Obj);

            }
          })
        })
      }
    }
    this.initialAdditionalLoad = true;
  }
  async MapAlternatePart()
  {
    if(this.partList.alternatePartList)
    {
      if (this.alternatePartsList && this.partList.alternatePartList?.length > 0) {
        this.alternatePartsList.forEach(x => {
          this.partList.alternatePartList.forEach(y => {
            if (x.partNumber == y.alternatePartNumber) {
              let Obj = {
                id:x.id,
                description:x.description
              };
              this.selectedAlternateItems.push(Obj);

            }
          })
        })
      }
    }
    this.initialAlternateLoad = true;
  }
  async MapReplacementPart()
  {
    if(this.partList.replacementPartList)
    {
      if (this.replacementPartsList && this.partList.replacementPartList?.length > 0) {
        this.replacementPartsList.forEach(x => {
          this.partList.replacementPartList.forEach(y => {
            if (x.partNumber == y.replacementPartNumber) {
              let Obj = {
                id:x.id,
                description:x.description
              };
              this.selectedReplacementItems.push(Obj);

            }
          })
        })
      }
    }
    this.initialReplacementLoad = true;
  }
  get cpf(): any {
    return this.editPartForm.controls;
  }

  onBlur(event){
    this.partList.partLists[0].unitPrice = event.target.value;
  }

  onSubmit(): void {
    let selectedAdditionalItems = [];
    let selectedAlternateItems = [];
    let selectedReplacementItems = [];
    let additionalError = ''; let alternateError = ''; let replacementError = '';
    this.selectedAdditionalItems.forEach(x =>
      {
        if(this.additionalPartsList.filter(y => y.id == x.id)[0].hasAdditionalItems || this.additionalPartsList.filter(y => y.id == x.id)[0].hasAlternativeItems || this.additionalPartsList.filter(y => y.id == x.id)[0].hasReplacementItems){
          additionalError = this.translate.instant("lblCantAddAdditionalPart");
        }
        else{
          let Obj:AdditionalPartList = {
            additionalPartId : x.id,
            additionalPartNumber: this.additionalPartsList.filter(y => y.id == x.id)[0].partNumber
           };
           selectedAdditionalItems.push(Obj);
        }
      });
    this.selectedAlternateItems.forEach(x =>
        {
          if(this.alternatePartsList.filter(y => y.id == x.id)[0].hasAdditionalItems || this.alternatePartsList.filter(y => y.id == x.id)[0].hasAlternativeItems || this.alternatePartsList.filter(y => y.id == x.id)[0].hasReplacementItems){
            alternateError = this.translate.instant("lblCantAddAlternatePart");
          }
          else{
            let Obj:AlternatePartList = {
              alternatePartId : x.id,
              alternatePartNumber: this.alternatePartsList.filter(y => y.id == x.id)[0].partNumber
             };
             selectedAlternateItems.push(Obj);
          }
    });
    this.selectedReplacementItems.forEach(x =>
          {
            if(this.replacementPartsList.filter(y => y.id == x.id)[0].hasAdditionalItems || this.replacementPartsList.filter(y => y.id == x.id)[0].hasAlternativeItems || this.replacementPartsList.filter(y => y.id == x.id)[0].hasReplacementItems){
              replacementError = this.translate.instant("lblCantAddReplacementPart");
            }
            else{
              let Obj:ReplacementPartList = {
                replacementPartId : x.id,
                replacementPartNumber: this.replacementPartsList.filter(y => y.id == x.id)[0].partNumber,
                makeCode: this.replacementPartsList.filter(y => y.id == x.id)[0].makeCode
               };
               selectedReplacementItems.push(Obj);
            }
    });
    if(additionalError != '') this.toaster.error(additionalError);
    if(alternateError != '') this.toaster.error(alternateError);
    if(replacementError != '') this.toaster.error(replacementError);
    if(additionalError != '' || alternateError != '' || replacementError != ''){
      this.spinner.hide();
      return;
    }
    const viewModel: any = {
      Lnlnvalue: this.editPartForm.value.service,
      id:this.partList.partLists.id,
      partNumber: this.partList.partLists.partNumber,
      isActive: (this.editPartForm.get('isActive').value === '' ? false : this.editPartForm.get('isActive').value),
      unitPrice:+this.globalSetting.getFormattedprice(this.cpf.unitPrice.value),
      makeCode: this.makeCode,
      selectedAdditionalItems: selectedAdditionalItems,
      selectedAlternateItems:selectedAlternateItems,
      selectedReplacementItems:selectedReplacementItems,
      isFixed: ((this.editPartForm.get('isFixed')?.value === '' || this.editPartForm.get('isFixed')?.value === null) ? false : this.editPartForm.get('isFixed').value),
      userId:this.userService.currentUserValue.userId
    };
    this.spinner.show();
    this.partService.addParts(viewModel).then((res) => {
      if (res.responseCode === Enums.ErrorCodes.SuccessCode) {
        if(res.responseObject.isSuccess && res.responseObject.retValue == '0'){
          this.spinner.hide();
          let errorErr = this.translate.instant("lblPartExist");
          this.toaster.error(errorErr);
        }
        else if(res.responseObject.isSuccess && res.responseObject.retValue != '0'){
          let successMsg = this.translate.instant("lblPartAdded");
          this.toaster.success(successMsg);
          this.activeModal.close({ success: true
          });
        }
        else{
          let errorErr = this.translate.instant("lblUnknownErrorOccured");
          this.toaster.error(errorErr);
          this.spinner.hide();
        }
      }
      this.spinner.hide();
    });
  }
  OnClose(){
    this.activeModal.dismiss('Cross click')
  }
  ngOnDestroy(): void {
    //do Something

  }
}
